import { ComponentRef, ViewContainerRef } from '@angular/core';
import { FormControl } from '@angular/forms';
import { FieldValidation } from '../../field-validation';
import { FieldValueInterface, ObjectType, RenderableFieldInterface } from '../../../../tokens-and-interfaces';
import { FloatRendererComponent } from './float';

export class FloatFieldHandler implements RenderableFieldInterface {
  private component: ComponentRef<FloatRendererComponent> | null = null;
  formControl: FormControl<number>;

  constructor(
    public objectType: ObjectType,
    public fieldId: string,
    public name: string,
    public label: string,
    public value: number,
    public description: string,
    public readOnly = false,
    public validation: FieldValidation = new FieldValidation(),
  ) {
    this.formControl = new FormControl(this.value);
  }

  setValidation(validation: FieldValidation): void {
    this.validation = validation;
    this.formControl.setValidators(validation.getValidators());
    this.formControl.setAsyncValidators(validation.getAsyncValidators());
  }

  render(viewContainerRef: ViewContainerRef): void {
    viewContainerRef.clear();
    const component = viewContainerRef.createComponent<FloatRendererComponent>(FloatRendererComponent);
    component.instance.fieldId = this.fieldId;
    component.instance.objectType = this.objectType;
    component.instance.control = this.formControl;
    component.instance.label = this.label;
    component.instance.validation = this.validation;
    component.instance.readOnly = this.readOnly;
    this.component = component;
  }

  hasModification(): boolean {
    return this.formControl?.dirty;
  }

  fieldValue(): FieldValueInterface {
    return {
      fieldId: this.fieldId,
      floatValue: this.formControl.value,
    };
  }
}
